import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "24",
  height: "24",
  viewBox: "0 0 26 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.7 10c-.9 0-1.7.8-1.7 1.7v10.7c0 .8.8 1.6 1.7 1.6h18.7c.9 0 1.7-.8 1.7-1.7V11.7c0-.9-.8-1.7-1.7-1.7zM0 11.7C0 9.6 1.6 8 3.7 8h18.7c2 0 3.7 1.6 3.7 3.7v10.7c0 2-1.6 3.7-3.7 3.7H3.7c-2 0-3.7-1.6-3.7-3.7z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.1 6c-.9 0-1.7.8-1.7 1.7V9c0 .6-.4 1-1 1s-1-.4-1-1V7.7C2.4 5.6 4 4 6.1 4H20c2 0 3.7 1.6 3.7 3.7V9c0 .6-.4 1-1 1s-1-.4-1-1V7.7c0-.9-.8-1.7-1.7-1.7z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.3 2c-.9 0-1.6.8-1.6 1.7V5c0 .6-.4 1-1 1s-1-.4-1-1V3.7c0-2 1.6-3.7 3.7-3.7h9.3c2 0 3.7 1.6 3.7 3.7V5c0 .6-.4 1-1 1s-1-.4-1-1V3.7c0-.9-.8-1.7-1.7-1.7zM18.1 13.2c.3.3.3.8 0 1l-5.7 5.2c-.3.3-.8.3-1.1 0l-3.4-3.1c-.3-.3-.3-.8 0-1 .3-.3.8-.3 1.1 0l2.8 2.6 5.1-4.7c.4-.3.9-.3 1.2 0",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0000e7"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }